/**
 * Validation format patterns for Dutch and international data
 *
 * Based on official government specifications and EU standards (2024/2025)
 */

export const NL_FORMATS = {
  /**
   * Dutch Postal Code (Postcode)
   * Format: 4 digits (1-9 first) + optional space + 2 letters
   * Excludes: SA, SD, SS (historical Nazi association)
   * Cannot start with 0
   * Example: 1234AB or 1234 AB
   */
  POSTAL_CODE: /^[1-9]\d{3}\s?(?!SA|SD|SS)[A-Z]{2}$/i,

  /**
   * Dutch KVK Number (Chamber of Commerce)
   * Format: Exactly 8 digits
   * Example: 12345678
   */
  KVK_NUMBER: /^\d{8}$/,

  /**
   * Dutch BTW-ID (VAT Identification Number)
   * Format: NL + 12 characters (digits, letters, +, *)
   * Since Jan 2020: More flexible than old NL\d{9}B\d{2} format
   * Example: NL123456789B01 (most common)
   * Note: This is lenient - actual validation should use VIES API
   */
  BTW_ID_BASIC: /^NL[A-Z0-9+*]{12}$/i,

  /**
   * Common BTW-ID pattern (most Dutch VAT numbers follow this)
   * Format: NL + 9 digits + B + 2 digits
   * Example: NL123456789B01
   * Note: Not all valid BTW-IDs match this - use BTW_ID_BASIC for acceptance
   */
  BTW_ID_COMMON: /^NL\d{9}B\d{2}$/i,
}

export const INTERNATIONAL_FORMATS = {
  /**
   * International VAT Number (very basic check)
   * Format: 2-letter country code + 2-12 alphanumeric characters
   * Examples: BE0123456789, DE123456789, FR12345678901
   * Note: Use VAT validation library (jsvat) for proper validation
   */
  VAT_NUMBER: /^[A-Z]{2}[A-Z0-9+*]{2,12}$/i,
}
